

var BILLING_ADDRESS_FORMAT = {
    DEFAULT: {
        ',': ', ',
        ' ': ' '
    },
    IL: {
        he: {
            ',': '‏, ‏',
            ' ': '‏ ‏'
        }
    }
};

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.fi', ['squid']).factory('$CardModel', function ($Model, $util) {
        return $Model.extend('CardModel', {

            serialize: function serialize() {

                return {
                    type: this.type,
                    number: this.number.replace(/[^\d]+/g, ''),
                    security_code: this.security_code,
                    expiry_month: this.expiry_month && $util.pad(this.expiry_month, 2),
                    expiry_year: this.expiry_year,
                    issue_number: this.issue_number ? this.issue_number : undefined,
                    start_month: this.start_month ? $util.pad(this.start_month, 2) : undefined,
                    start_year: this.start_year ? this.start_year : undefined
                };
            },

            last4: function last4() {
                var cardNumber = this.number;
                return cardNumber.substr(cardNumber.length - 4);
            },

            isExisting: function isExisting() {
                return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
            }
        });
    }).factory('$AddCardModel', function ($Model, $Api, $CardModel) {
        return $Model.extend('AddCardModel', {

            api: new $Api({
                uri: '/api/fi/card/:id?'
            }),

            init: function init() {
                this._super.init.apply(this);
                this.card = new $CardModel();
            },

            serialize: function serialize() {
                var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;

                return {
                    cardType: this.cardType ? this.cardType : 'creditCard',
                    sponsor_id: this.sponsor_id,
                    preference: this.preference,
                    user: this.user,
                    card: this.card.serialize(),
                    address: id ? {
                        id: id
                    } : this.address.serialize()
                };
            },

            clearId: function clearId() {
                delete this.id;
            }
        });
    }).factory('$CardTypesModel', function ($Model, $Api, $locale, $util, $feature) {
        return $Model.extend('CardTypesModel', {

            api: new $Api({
                uri: '/api/fi/card/types?country=:country&token=:token'
            }),

            retrieve: function retrieve() {
                return this._super.retrieve.apply(this, arguments).then(function (result) {
                    // QIWI is VISA cobranded card supported currently in Russia.
                    if ($feature('qiwiCardSupported') && result.allowed && result.allowed.indexOf('VISA') > -1 && result.allowed.indexOf('QIWI') === -1) {
                        result.allowed.push('QIWI');
                    }
                    return result;
                });
            },

            supportedNames: function supportedNames() {
                return $util.map(this.allowed, function (type) {
                    return $locale.content.cardTypes[type];
                });
            }
        });
    }).factory('$BankModel', function ($Model) {
        return $Model.extend('BankModel', {

            init: function init() {
                this._super.init.apply(this);
                this.bank_account_number = '';
                this.bank_routing_number = '';
                this.iban_number = '';
            },

            serialize: function serialize() {
                var data = {};

                if (this.bank_account_number) {
                    data.bank_account_number = this.bank_account_number;
                }
                if (this.bank_routing_number) {
                    data.bank_routing_number = this.bank_routing_number;
                }
                if (this.iban_number) {
                    data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
                }
                return data;
            }
        });
    }).factory('$AddBankModel', function ($Model, $Api, $BankModel) {

        return $Model.extend('AddBankModel', {

            api: new $Api({
                uri: '/api/fi/bank'
            }),

            init: function init() {
                this._super.init.apply(this);
                this.user = this.user || {
                    first_name: '',
                    dob_day: '',
                    dob_month: '',
                    dob_year: '',
                    currency_code: '',
                    country: ''
                };
                this.bank = this.bank || new $BankModel();
                this.address = this.address || {};
                this.creditorDetails = this.creditorDetails || {};
                this.fiDetails = this.fiDetails || {};
            },

            getBankData: function getBankData() {
                var data = {};

                // Set user info
                data.user = this.user;

                // Set bank info
                var bank = {};

                this.bank = this.bank || {};

                if (this.candidate_id) {
                    data.candidate_id = this.candidate_id;
                }

                if (this.bank.bank_account_number) {
                    bank.bank_account_number = this.bank.bank_account_number;
                }

                if (this.bank.bank_routing_number) {
                    bank.bank_routing_number = this.bank.bank_routing_number;
                }

                if (this.bank.iban_number) {
                    bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
                }
                data.bank = bank;

                // Set address info
                if (this.address) {
                    data.address = {
                        line1: this.address.line1,
                        line2: this.address.line2,
                        city: this.address.city,
                        country: this.address.country,
                        postal_code: this.address.postal_code
                    };
                }

                return data;
            }
        });
    }).factory('$SepaModel', function ($Model, $Api) {
        return $Model.extend('SepaModel', {
            api: new $Api({
                uri: '/api/fi/bank'
            })
        });
    }).factory('$DeleteCardModel', function ($Model, $Api) {
        return $Model.extend('DeleteCardModel', {
            api: new $Api({
                uri: '/api/fi/card/:id/delete'
            })
        });
    }).factory('$BillingAddressModel', function ($Model, $Api, $config, $util, $locale) {
        return $Model.extend('BillingAddressModel', {
            api: new $Api({
                uri: '/api/fi/billingaddress/validate'
            }),

            format: function format() {

                var langConfig = (BILLING_ADDRESS_FORMAT[$locale.country] || {})[$locale.lang] || {};

                var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
                var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];

                return $util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + $util.filter([this.postal_code]);
            },

            serialize: function serialize() {
                return {
                    line1: this.line1,
                    line2: this.line2,
                    city: this.city,
                    state: this.state,
                    postal_code: this.postal_code,
                    normalization_status: this.normalization_status,
                    country: this.country
                };
            }
        });
    }).factory('$BillingAddressesModel', function ($Model, $BillingAddressModel, $Api, $config, $util) {
        return $Model.extend('BillingAddressesModel', {
            api: new $Api({
                uri: '/api/fi/billingaddress'
            }),

            onPopulate: function onPopulate() {
                this.addresses = this.children($BillingAddressModel, this.addresses);
            }
        });
    }).factory('$CardTypeFromBinModel', function ($Model, $Api) {
        return $Model.extend('CardTypeFromBinModel', {
            api: new $Api({
                uri: '/api/fi/cardTypeFromBin?country=:country&bin=:bin&user_country=:user_country'
            })
        });
    }).factory('$Resolve3DS', function ($Model, $Api) {
        return $Model.extend('Resolve3DS', {
            api: new $Api({
                uri: '/api/fi/3ds/:id'
            })
        });
    }).factory('$ResolveOTP', function ($Model, $Api) {
        return $Model.extend('ResolveOTP', {
            api: new $Api({
                uri: '/api/fi/otp/:id'
            })
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/fi/index.js
 ** module id = 234
 ** module chunks = 1
 **/